import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UpdateFormStatus, UpdateFormValue } from '@ngxs/form-plugin';
import { GlobalState } from '@store/states/global.state';
import { FormViolation, GlobalRouteData } from '@domain/models/shared.models';
import { SetFormViolations, SetRouteData } from '@store/actions/global.actions';
import { GLOBAL_STATE_TOKEN } from '@shared/constants/global.constants';

@Injectable()
export class GlobalFacade {
  @Select(GlobalState.routeData) routeData$!: Observable<
    ReturnType<typeof GlobalState.routeData>
  >;

  @Select(GlobalState.formViolations) formViolations$!: Observable<
    ReturnType<typeof GlobalState.formViolations>
  >;

  constructor(private store: Store) {}

  // Action Dispatchers
  setRouteData(data: GlobalRouteData): Observable<unknown> {
    return this.store.dispatch(new SetRouteData(data));
  }

  setFormViolations(data: FormViolation[] | undefined): Observable<unknown> {
    return this.store.dispatch(new SetFormViolations(data));
  }

  handleFormViolations(
    error: HttpErrorResponse,
    fields?: Record<string, unknown>
  ): Observable<unknown> | undefined {
    let violations = error.error?.violations as FormViolation[] | undefined;
    if (fields && violations) {
      violations = violations.filter(el =>
        Object.keys(fields).some(field => el.propertyPath.includes(field))
      );
    }
    if (violations?.length) {
      return this.setFormViolations(violations);
    }
    return;
  }

  updateFormStatus(status: string, path: string): Observable<unknown> {
    return this.store.dispatch(new UpdateFormStatus({ status, path }));
  }

  updateFormValue(
    value: Record<string, unknown> | string | number,
    path: string,
    propertyPath?: string
  ): Observable<unknown> {
    return this.store.dispatch(
      new UpdateFormValue({ value, path, propertyPath })
    );
  }

  // Snapshots
  getRouteData(): GlobalRouteData | undefined {
    return this.store.selectSnapshot(GLOBAL_STATE_TOKEN).routeData;
  }

  getFormViolations(): FormViolation[] | undefined {
    return this.store.selectSnapshot(GLOBAL_STATE_TOKEN).formViolations;
  }
}
